import React, { useEffect } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { CONTENT_MIN_WIDTH } from '../../common/constants.tsx';
import { addTabContentEntryPoint } from './entrypoint.tsx';
import { LoadingSkeleton } from './loading-skeleton/index.tsx';

type AsyncMenuContentProps = {
	closeDropdown: () => void;
};

export const AsyncMenuContent = ({ closeDropdown }: AsyncMenuContentProps) => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(addTabContentEntryPoint, {
		closeDropdown,
	});

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		entryPointActions.load();
	}, [entryPointActions]);

	return (
		<Box xcss={addTabContentWrapperStyles}>
			<JiraEntryPointContainer
				entryPointReferenceSubject={entryPointReferenceSubject}
				id="navigation-kit-add-tab-content"
				packageName="jiraNavigationKitAddTab"
				runtimeProps={{ closeDropdown }}
				fallback={<LoadingSkeleton />}
			/>
		</Box>
	);
};

const addTabContentWrapperStyles = xcss({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	inlineSize: `${CONTENT_MIN_WIDTH}px`,
});
